import script from "./AnnouncementPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementPreview.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementPreview.vue?vue&type=style&index=0&id=2639ed57&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2639ed57"]])

export default __exports__